/* RESPONSIBLE TEAM: team-standalone */

import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { taskFor } from 'ember-concurrency-ts';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import { StandalonePlatform } from 'embercom/objects/standalone/constants';
import { ReactRoute } from 'embercom/lib/react-route';

class IntegrationRoute extends Route {
  queryParams = {
    connectionType: { refreshModel: false },
  };

  @service declare appService: {
    app: {
      hasStandalonePlatform(platform: string): boolean;
      canStandalonePlatformAccessReactIntegrationPages: boolean;
      canUseReactSalesforceDataPage: boolean;
    };
  };
  @service declare finStandaloneService: FinStandaloneService;

  reactEnabled() {
    return (
      this.appService.app.canStandalonePlatformAccessReactIntegrationPages &&
      (!this.appService.app.hasStandalonePlatform(StandalonePlatform.Salesforce) ||
        this.appService.app.canUseReactSalesforceDataPage)
    );
  }

  async beforeModel() {
    let promises: Promise<void>[] = [];

    promises.push(this.finStandaloneService.platform.loadRequiredData());

    if (this.appService.app.hasStandalonePlatform(StandalonePlatform.Freshdesk)) {
      if (this.finStandaloneService.isLoadingFreshdeskConfig) {
        promises.push(taskFor(this.finStandaloneService.loadFreshdeskConfig).lastRunning!);
      } else {
        promises.push(taskFor(this.finStandaloneService.loadFreshdeskConfig).perform());
      }
    }

    await Promise.all(promises);
  }
}

export default ReactRoute(IntegrationRoute);
